// TODO: This component should be refactored to use `glints-aries`Input components with formik
import React, { Component, Fragment } from 'react';
import {
  CheckmarkIcon,
  ExclamationIcon,
  PrimaryColor,
  SecondaryColor,
} from 'glints-aries';
import isNil from 'lodash/isNil';
import PropTypes from 'prop-types';

import * as Input from './InputComponents.sc';
import PasswordStrengthIndicator from './PasswordStrengthIndicator';
import { passwordIconWrapper } from './styles';

class FloatingLabelInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      floating: false,
      focused: false,
    };

    this.isFloating = this.isFloating.bind(this);
  }

  handleFocusChange(evt) {
    if (evt.type === 'focus') {
      this.props.onFocus(evt);
    } else {
      this.props.onBlur(evt);
    }
    this.setState({
      focused: !this.state.focused,
    });
  }

  isFloating() {
    const { focused } = this.state;
    const { value } = this.props;

    return focused || Boolean(!isNil(value) && value.toString());
  }

  renderRightElement() {
    const { touched, type, value, valid } = this.props;
    const rightElementIcons = [];

    rightElementIcons.push(
      <Fragment>
        <If condition={touched && valid}>
          <CheckmarkIcon color={SecondaryColor.green} />
        </If>
        <If condition={!valid}>
          <ExclamationIcon color={PrimaryColor.glintsred} />
        </If>
      </Fragment>
    );

    if (type === 'password') {
      rightElementIcons.push(
        <div key="password" style={passwordIconWrapper}>
          <PasswordStrengthIndicator password={value} />
        </div>
      );
    }

    return rightElementIcons;
  }

  renderInputElement() {
    return (
      <Fragment>
        <If condition={this.props.renderInputElement}>
          {this.props.renderInputElement()}
        </If>
        <If condition={!this.props.renderInputElement}>
          <Input.InputType
            {...this.props}
            placeholder=""
            onBlur={evt => this.handleFocusChange(evt)}
            onChange={evt => this.props.onChange(evt)}
            onFocus={evt => this.handleFocusChange(evt)}
            floating={this.isFloating()}
          />
        </If>
      </Fragment>
    );
  }

  render() {
    const { name } = this.props;
    return (
      <Input.InputWrapper>
        <Input.InputName floating={this.isFloating()}>
          {this.props.placeholder}
        </Input.InputName>
        <Input.InputTypeWrapper
          onBlur={evt => this.handleFocusChange(evt)}
          onFocus={evt => this.handleFocusChange(evt)}
        >
          {this.renderInputElement()}
          <Input.ValidationIconContainer shouldShiftLeft={name === 'location'}>
            {this.renderRightElement()}
          </Input.ValidationIconContainer>
        </Input.InputTypeWrapper>
      </Input.InputWrapper>
    );
  }
}

FloatingLabelInput.propTypes = {
  autoCapitalize: PropTypes.oneOf(['none', 'sentences', 'words', 'characters']),
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  element: PropTypes.oneOf(['input', 'textarea']),
  error: PropTypes.node,
  id: PropTypes.string.isRequired,
  inputMode: PropTypes.string,
  max: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  minLength: PropTypes.number,
  name: PropTypes.string,
  noRightElement: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  pattern: PropTypes.any,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  readOnly: PropTypes.bool,
  renderInputElement: PropTypes.func,
  required: PropTypes.bool,
  spellCheck: PropTypes.bool,
  step: PropTypes.number,
  touched: PropTypes.bool,
  type: PropTypes.oneOf([
    'text',
    'password',
    'url',
    'search',
    'email',
    'tel',
    'number',
  ]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valid: PropTypes.bool,
};

FloatingLabelInput.defaultProps = {
  autoFocus: false,
  disabled: false,
  element: 'input',
  name: '',
  className: 'field',
  noRightElement: false,
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  renderInputElement: null,
  placeholder: '',
  readOnly: false,
  required: false,
  step: 1,
  styles: {},
  touched: false,
  type: 'text',
  value: '',
  valid: true,
};

export default FloatingLabelInput;
